// this serves as a placeholder for the akamai adapter
// when the module is enabled it will override this file
// allowing to use the akamai adapter.

import ImageAdapter from "theme/components/atoms/Image/ImageAdapter";

class AkamaiAdapter extends ImageAdapter {
  name = "AkamaiAdapter";
  supportSrc() {
    return false;
  }
}

export default new AkamaiAdapter();
